module.exports = __webpack_public_path__ + "img/pause-icon.aa346ca4.svg";